export default __webpack_public_path__ + "static/media/emptyFavoriteIcon.d03d5a13.svg";